import { Component, OnInit } from '@angular/core';
import { Router }              from '@angular/router';
import { Type }            from '../data/formData.model';
import { FormDataService }     from '../data/formData.service';

@Component({
  selector: 'app-art-wohnung',
  templateUrl: './art-wohnung.component.html',
  styleUrls: ['./art-wohnung.component.scss']
})
export class ArtWohnungComponent implements OnInit {

  title = 'Bitte wählen Sie die Art Ihrer Wohnung';
  type: Type;
  form: any;
  
  constructor(private router: Router, private formDataService: FormDataService) {
  }

  ngOnInit() {
      this.type = this.formDataService.getType();
      console.log('Art der Wohnung feature loaded!');
  }

  save(type: string): boolean {
      this.formDataService.setType(type);
      return true;
  }

  goToNext(form: any) {
      if (this.save(form)) {
          // Navigate to the work page
          this.sendMessage('movetop');
          this.router.navigate(['/wohnung-step2']);
      }
  }

  goToPrevious(form: any) {
      if (this.save(form)) {
          // Navigate to the personal page
          this.formDataService.resetFormData();
          this.sendMessage('movetop');
          this.router.navigate(['/main']);
      }
  }

   // Send a message to the parent
   sendMessage(msg: string) {
    window.parent.postMessage(msg, '*');
   }

}
